import { DataFetcherError } from './DataFetcherError';

export enum DataFetcherMethod {
	Get = 'GET',
	Post = 'POST',
	Put = 'PUT',
	Patch = 'PATCH',
	Delete = 'DELETE',
}

export interface DataFetcherProps {
	method: DataFetcherMethod;
	url: string;
	body?: BodyInit;
	headers?: HeadersInit;
	signal?: AbortSignal; // To cancel runing fetch; https://tanstack.com/query/v4/docs/framework/react/guides/query-cancellation
}

export class DataFetcher {
	async execute<T>({
		url,
		method,
		body,
		headers: customHeaders,
		signal,
	}: DataFetcherProps) {
		const headers = { ...customHeaders, 'Content-Type': 'application/json' };

		const response = await fetch(url, {
			method,
			body,
			headers,
			signal,
		});

		const data = ((await response?.json()) as T) ?? undefined;

		// Throw error if response is not 2xx
		if (!response.ok) {
			throw new DataFetcherError(
				response.statusText,
				url,
				method,
				response.status,
				data
			);
		}

		return {
			response,
			data,
			statusCode: response.status,
		};
	}
}
